/**
 * Talkomo 的 logo（E5-02-01）。
 *
 * Mark＝兩個相交的圓：實心藍是線上、描邊橘是線下（門市），**交會的地方長出
 * 對話氣泡的尾巴**——線上與線下交會處就是對話，這是 OMO 的視覺直譯，
 * 也是整個產品一句話的自我介紹。
 *
 * 名字與 mark 只住在這裡＋i18n 的 app_title＋index.html——換品牌是改三個檔案。
 */

const BRAND_BLUE = '#3054c4';
const OMO_ORANGE = '#e8853d';

/** tone='light'：放在深藍 rail 上的版本（E5-03-02）——藍圓換白，橘圈不變。 */
export type LogoTone = 'default' | 'light';

export function LogoMark({ size = 28, tone = 'default' }: { size?: number; tone?: LogoTone }) {
  const bubble = tone === 'light' ? '#ffffff' : BRAND_BLUE;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* 線上：實心圓 */}
      <circle cx="12.5" cy="14" r="9.5" fill={bubble} />
      {/* 線下：描邊圓，跟實心圓相交 */}
      <circle cx="21.5" cy="14" r="8" stroke={OMO_ORANGE} strokeWidth="2.6" fill="none" />
      {/* 交會處長出的氣泡尾巴 */}
      <path d="M14.5 22.5 L13 28.5 L19 23.5 Z" fill={bubble} />
    </svg>
  );
}

export function Logo({
  size = 28,
  withWordmark = true,
  tone = 'default',
}: {
  size?: number;
  withWordmark?: boolean;
  tone?: LogoTone;
}) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <LogoMark size={size} tone={tone} />
      {withWordmark && (
        <span
          style={{
            fontFamily: 'var(--font-numeric)',
            fontWeight: 700,
            fontSize: size * 0.68,
            letterSpacing: '-0.03em',
            color: tone === 'light' ? '#ffffff' : 'var(--text-primary)',
            lineHeight: 1,
          }}
        >
          talkomo
        </span>
      )}
    </span>
  );
}
